import { LINK } from 'utils';

const {
  TARGET: {
    DEFAULT: { VALUES: TARGET_DEFAULT_VALUES },
  },
} = LINK;

type State = Partial<
  Record<
    'linkAttributes',
    Partial<
      Record<'href', string> &
        Record<'target', (typeof TARGET_DEFAULT_VALUES)[number]> &
        Record<'rels', string[]>
    >
  > &
    Record<
      'imageAttributes',
      Partial<
        Record<'id' | 'src' | 'name' | 'alt', string> &
          Record<'width' | 'height', number>
      >
    > &
    Record<
      'videoAttributes',
      Partial<
        Record<'id' | 'src' | 'name', string> &
          Record<'width' | 'height', number>
      >
    > &
    Record<'audioAttributes', Partial<Record<'id' | 'src' | 'name', string>>> &
    Record<
      'iframeAttributes',
      Partial<Record<'src', string> & Record<'width' | 'height', number>>
    >
>;
const initialState: State = {};

type Action =
  | {
      type: 'UPDATE_RICH_TEXT_EDITOR_LINK_ATTRIBUTES';
      payload: Pick<typeof initialState, 'linkAttributes'>;
    }
  | {
      type: 'UPDATE_RICH_TEXT_EDITOR_IMAGE_ATTRIBUTES';
      payload: Pick<typeof initialState, 'imageAttributes'>;
    }
  | {
      type: 'UPDATE_RICH_TEXT_EDITOR_VIDEO_ATTRIBUTES';
      payload: Pick<typeof initialState, 'videoAttributes'>;
    }
  | {
      type: 'UPDATE_RICH_TEXT_EDITOR_AUDIO_ATTRIBUTES';
      payload: Pick<typeof initialState, 'audioAttributes'>;
    }
  | {
      type: 'UPDATE_RICH_TEXT_EDITOR_IFRAME_ATTRIBUTES';
      payload: Pick<typeof initialState, 'iframeAttributes'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
